<!-- <mwc-tabset>
  <mwc-tab [mwcTitle]="all" (mwcClick)="onTabSelect('all')"></mwc-tab>
  <mwc-tab [mwcTitle]="web" (mwcClick)="onTabSelect('web')"></mwc-tab>
  <mwc-tab [mwcTitle]="news" (mwcClick)="onTabSelect('news')"></mwc-tab>
  <mwc-tab [mwcTitle]="social" (mwcClick)="onTabSelect('social')"></mwc-tab>
  <mwc-tab [mwcTitle]="media" (mwcClick)="onTabSelect('media')"></mwc-tab>
  <mwc-tab [mwcTitle]="advertising" (mwcClick)="onTabSelect('advertising')"></mwc-tab>
  <mwc-tab [mwcTitle]="emails" (mwcClick)="onTabSelect('emails')"></mwc-tab>
  <ng-template #all> <span class="mwc-text-sm-medium">All Templates </span> <mwc-tag
          [mwcColor]="tabs['all'] ? 'primary' : 'gray'">{{templatesCount['all']}}</mwc-tag></ng-template>
  <ng-template #web> <span class="mwc-text-sm-medium"> Web </span> <mwc-tag
          [mwcColor]="tabs['web'] ? 'primary' : 'gray'">{{templatesCount['web']}}</mwc-tag></ng-template>
  <ng-template #news> <span class="mwc-text-sm-medium"> News </span> <mwc-tag
          [mwcColor]="tabs['news'] ? 'primary' : 'gray'">{{templatesCount['news']}}</mwc-tag></ng-template>
  <ng-template #social> <span class="mwc-text-sm-medium"> Social </span> <mwc-tag
          [mwcColor]="tabs['social'] ? 'primary' : 'gray'">{{templatesCount['social']}}</mwc-tag></ng-template>
  <ng-template #media> <span class="mwc-text-sm-medium"> Media </span> <mwc-tag
          [mwcColor]="tabs['media'] ? 'primary' : 'gray'">{{templatesCount['media']}}</mwc-tag></ng-template>
  <ng-template #advertising> <span class="mwc-text-sm-medium"> Advertising </span> <mwc-tag
          [mwcColor]="tabs['advertising'] ? 'primary' : 'gray'">{{templatesCount['advertising']}}</mwc-tag></ng-template>
  <ng-template #emails> <span class="mwc-text-sm-medium"> Emails </span> <mwc-tag
          [mwcColor]="tabs['emails'] ? 'primary' : 'gray'">{{templatesCount['emails']}}</mwc-tag></ng-template>
</mwc-tabset> -->
<div class="py-3 template-container">
  <div class="template-nav">
    <div style="width: 95%;margin: 0 auto 12px 0;" *ngIf ="!isViewDetails">
      <mwc-input-group [mwcPrefix]="prefixIconSearch">
        <input mwc-input [formControl]="searchField" type="text" class="mwc-text-sm-regular" [(ngModel)]="searchTxt" (keyup)="triggerSearch()"  placeholder="Search" mwcSize="small" />
      </mwc-input-group>
      <ng-template #prefixIconSearch>
        <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
      </ng-template>
    </div>
    <ul mwc-menu [mwcSelectable]="true" class="template-menu" (mwcClick)="menuEvent($event)">
      <li mwc-menu-item mwcSelected>
        <a>
          <span mwc-icon mwcIconfont="layout-alt-02"></span>All Workflows
        </a>
      </li>
      <li mwc-menu-item>
        <a>
          <span mwc-icon mwcIconfont="star-02"></span>Favorites
        </a>
      </li>
      <li mwc-submenu [mwcPaddingLeft]="12" [(mwcOpen)]="openMap.sub1" (mwcOpenChange)="openHandler('sub1')" mwcTitle="Marketing Function" [mwcIcon]="'dataflow-01'" (click)="getAllChildTemplateTypes('Marketing Function')" class="marketing-fun">
        <ul>
          <ng-container *ngFor="let item of childTemplateTypes">
            <li  mwc-menu-item>
              <a>
                <span mwc-icon [mwcIconfont]="item.icon"></span>
                {{ item.templateTypeName }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
      <li mwc-submenu [mwcPaddingLeft]="12" [(mwcOpen)]="openMap.sub2" (mwcOpenChange)="openHandler('sub2')" mwcTitle="Content Type" [mwcIcon]="'pen-tool-02'" (click)="getAllChildTemplateTypes('Content Type')">
        <ul>
          <ng-container *ngFor="let item of childTemplateTypes">
            <li mwc-menu-item>
              <a>
                <span mwc-icon [mwcIconfont]="item.icon"></span>
                {{ item.templateTypeName }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
      <li mwc-submenu [mwcPaddingLeft]="12" [(mwcOpen)]="openMap.sub3" (mwcOpenChange)="openHandler('sub3')" mwcTitle="Funnel" [mwcIcon]="'filter-funnel-02'" (click)="getAllChildTemplateTypes('Funnel')">
        <ul>
          <ng-container *ngFor="let item of childTemplateTypes">
            <li mwc-menu-item>
              <a>
                <span mwc-icon [mwcIconfont]="item.icon"></span>
                {{ item.templateTypeName }}
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
      <!-- <li mwc-menu-item *ngIf="isCustomTemplatesEnabled">
        <a>
          <span mwc-icon mwcIconfont="settings-02"></span>Custom Templates
        </a>
      </li> -->
    </ul>
  </div>
  <div class="template-sec" *ngIf="!isViewDetails">
    <mwc-spin [mwcIndicator]="customSpinTpl" [mwcSpinning]="isTemplateLoading" class="ps-3">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="mwc-text-lg-medium mwc-color-gray-900">{{selectedMenuValue}}</div>
        <div class="d-flex align-items-center gap-3">
          <span class="mwc-text-sm-medium">Filter by</span>
          <div>
            <mwc-select [mwcCustomTemplate]="defaultTemplate" [(ngModel)]="filterBy" (ngModelChange)="changeFilterBy($event)" [mwcDropdownClassName]="'mwc-xs-select-dropdown'" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium" style="width: 180px;" [mwcOptionHeightPx]="36">
              <mwc-option mwcCustomContent mwcLabel="Recommended" mwcValue="recommended">
                <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                  Recommended <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="filterBy == 'recommended'"></span>
                </div>
              </mwc-option>
              <mwc-option mwcCustomContent mwcLabel="Recently used" mwcValue="recently-used">
                <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                  Recently used <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="filterBy == 'recently-used'"></span>
                </div>
              </mwc-option>
              <mwc-option mwcCustomContent mwcLabel="Alphabetical order " mwcValue="alphabetical-order">
                <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                  Alphabetical order  <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="filterBy == 'alphabetical-order'"></span>
                </div>
              </mwc-option>
              <!--<mwc-option mwcCustomContent mwcLabel="Custom Templates" mwcValue="custom-templates">
                <div class="d-flex align-items-center justify-content-between" style="pointer-events: none;">
                  Custom Templates  <span mwc-icon mwcIconfont="check" class="mwc-color-primary-600" style="font-size: 18px;" *ngIf="filterBy == 'custom-templates'"></span>
                </div>
              </mwc-option>-->
            </mwc-select>
            <ng-template #defaultTemplate let-selected>
              {{selected.mwcLabel}}
            </ng-template>
          </div>
        </div>
      </div>
      
      <!-- Web Pages Banner Card -->
      <mwc-card *ngIf="showWebPagesCard" class="mb-3">
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column" style="flex: 1;">
            <div class="mwc-text-lg-semibold mwc-color-gray-900" style="margin-bottom: 8px;">Web Pages</div>
            <div class="mwc-text-sm-regular mwc-color-gray-600" style="margin-bottom: 36px;">Webpage content generation made easy. Generate content for your entire website and all it's pages through a single workflow.</div>
            <button mwc-button mwcType="default" mwcSize="small" style="width: 105px;" (click)="openWebPagesWorkflow()">
              <span class="mwc-text-sm-medium">Get Started</span>
            </button>
          </div>
          <div class="d-flex align-items-center justify-content-center" style="flex: 0 0 250px;">
            <img src="assets/images/custom-template-01.jpg" alt="Web Pages" style="max-height: 100%; max-width: 100%; border-radius: 12px;">
          </div>
        </div>
      </mwc-card>
      
      <cdk-virtual-scroll-viewport #templateContainer itemSize="200" class="templates-container" [style.height]="containerHeight" *ngIf="showWebPagesCard == false">
        <div class="templates-row" *cdkVirtualFor="let row of rowedData">
          <div class="template-card" (click)="onSelect(template)" *ngFor="let template of row">
            <div class="get-started-overlay">
              <button mwc-button mwcType="primary" mwcSize="small" (click)="initializeNewArticle('AI', template)" class="animation-btn animation-hover-btn">
                <span  class="inner-text">
                  <svg class="icon" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                    <path stroke-linejoin="round" stroke-linecap="round" stroke="currentColor" d="M14.187 8.096L15 5.25L15.813 8.096C16.0231 8.83114 16.4171 9.50062 16.9577 10.0413C17.4984 10.5819 18.1679 10.9759 18.903 11.186L21.75 12L18.904 12.813C18.1689 13.0231 17.4994 13.4171 16.9587 13.9577C16.4181 14.4984 16.0241 15.1679 15.814 15.903L15 18.75L14.187 15.904C13.9769 15.1689 13.5829 14.4994 13.0423 13.9587C12.5016 13.4181 11.8321 13.0241 11.097 12.814L8.25 12L11.096 11.187C11.8311 10.9769 12.5006 10.5829 13.0413 10.0423C13.5819 9.50162 13.9759 8.83214 14.186 8.097L14.187 8.096Z"></path>
                    <path
                    class="path"
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke="currentColor"
                    d="M6 14.25L5.741 15.285C5.59267 15.8785 5.28579 16.4206 4.85319 16.8532C4.42059 17.2858 3.87853 17.5927 3.285 17.741L2.25 18L3.285 18.259C3.87853 18.4073 4.42059 18.7142 4.85319 19.1468C5.28579 19.5794 5.59267 20.1215 5.741 20.715L6 21.75L6.259 20.715C6.40725 20.1216 6.71398 19.5796 7.14639 19.147C7.5788 18.7144 8.12065 18.4075 8.714 18.259L9.75 18L8.714 17.741C8.12065 17.5925 7.5788 17.2856 7.14639 16.853C6.71398 16.4204 6.40725 15.8784 6.259 15.285L6 14.25Z"
                    ></path>
                    <path
                    class="path"
                    stroke-linejoin="round"
                    stroke-linecap="round"
                    stroke="currentColor"
                    fill="currentColor"
                    d="M6.5 4L6.303 4.5915C6.24777 4.75718 6.15472 4.90774 6.03123 5.03123C5.90774 5.15472 5.75718 5.24777 5.5915 5.303L5 5.5L5.5915 5.697C5.75718 5.75223 5.90774 5.84528 6.03123 5.96877C6.15472 6.09226 6.24777 6.24282 6.303 6.4085L6.5 7L6.697 6.4085C6.75223 6.24282 6.84528 6.09226 6.96877 5.96877C7.09226 5.84528 7.24282 5.75223 7.4085 5.697L8 5.5L7.4085 5.303C7.24282 5.24777 7.09226 5.15472 6.96877 5.03123C6.84528 4.90774 6.75223 4.75718 6.697 4.5915L6.5 4Z"
                    ></path>
                  </svg>
                  Get Started
                </span>
              </button>
              <a mwc-button mwcType="link-color" mwcSize="small" (click)="viewDetailsEvent(template)">
                <span mwc-icon mwcIconfont="eye" style="font-size: 16px;"></span>
                <span class="mwc-text-sm-medium" style="font-size: 13px;">View Details</span>
              </a>
            </div>
            <mwc-tag *ngIf="template.isRecommended" class="tag" mwcColor="primary">Recommended</mwc-tag>
            <div class="template-card-heading">
              <div class="d-flex align-items-top justify-content-between w-100">
                <div class="featured-icon {{template.iconColor}}">
                  <span mwc-icon mwcIconfont={{template.icon}}></span>
                </div>
                <div class="temp-star" *ngIf="template.isFavorite">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <g clip-path="url(#clip0_23206_10030)">
                      <path d="M9.87135 1.60996C10.0421 1.19932 10.6239 1.19932 10.7947 1.60996L12.8608 6.57744C12.9328 6.75056 13.0956 6.86885 13.2825 6.88383L18.6453 7.31376C19.0886 7.3493 19.2684 7.90256 18.9306 8.19189L14.8447 11.6919C14.7023 11.8139 14.6401 12.0053 14.6836 12.1876L15.9319 17.4208C16.0351 17.8534 15.5645 18.1954 15.1849 17.9635L10.5936 15.1592C10.4336 15.0615 10.2324 15.0615 10.0724 15.1592L5.48107 17.9635C5.10152 18.1954 4.63089 17.8534 4.73409 17.4208L5.98239 12.1876C6.0259 12.0053 5.96371 11.8139 5.82132 11.6919L1.73542 8.19189C1.39765 7.90256 1.57742 7.3493 2.02074 7.31376L7.38355 6.88383C7.57045 6.86885 7.73325 6.75056 7.80526 6.57744L9.87135 1.60996Z" />
                    </g>
                    <defs>
                      <clipPath id="clip0_23206_10030">
                        <rect width="20" height="20" fill="white" transform="translate(0.333008)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div class="template-card-title mwc-text-md-medium mwc-color-gray-800">{{template.title}}</div>
            </div>
            <div class="mwc-text-sm-regular mwc-color-gray-600"> {{template.description}} </div>
          </div>
        </div>
        <div *ngIf="noTemplateExist">
          <div class="empty-state-msg" style="text-align: center;">
            <div class="image-center">
              <img src="assets/images/Illustration-search1.svg">
            </div>
            <div>
              <div class="mwc-text-lg-medium  mwc-color-gray-900 mb-2">No templates found</div>
              <div class="mwc-text-sm-regular mwc-color-gray-600">We cannot find anything related to your search, <br /> please search something else or select from the menu.</div>
            </div>
          </div>
        </div>
        <div *ngIf="childTemplates.length == 0 && selectedMenuValue == 'Favorites'">
          <div class="empty-state-msg" style="text-align: center;">
            <div class="image-center">
              <img src="assets/images/Illustration-nofavorites.svg">
            </div>
            <div>
              <div class="mwc-text-lg-medium  mwc-color-gray-900 mb-2">No favorites yet</div>
              <div class="mwc-text-sm-regular mwc-color-gray-600">Simply click on the star icon on template page to add any template into <br /> your favorites. </div>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </mwc-spin>
  </div>
  <div mwc-col [mwcSpan]="18" *ngIf="isViewDetails">
    <mwc-spin [mwcIndicator]="customSpinTpl" [mwcSpinning]="isTemplateLoading" class="ps-3">
      <div class="view-details-sec">
        <div class="d-flex align-items-center justify-content-between" style="border-bottom: 1px solid #EAECF0;padding-bottom: 12px;margin-bottom: 12px;">
          <div>
            <a mwc-button mwcType="link-color"  mwcSize="small" (click)="viewDetailsBackEvent()">
              <span mwc-icon mwcIconfont="arrow-left" style="font-size: 16px;"></span>
              <span class="mwc-text-sm-medium">Back</span>
            </a>
          </div>
          <div>
            <button mwc-button mwcSize="small" mwcType="default" *ngIf="!viewData.isFavorite" (click)="AddOrRemoveAsFav(viewData.templateId)">
              <span mwc-icon mwcIconfont="star-01" style="font-size: 16px;"></span>
              Mark as Favorite
            </button>
            <button mwc-button mwcSize="small" mwcType="default" *ngIf="viewData.isFavorite" (click)="AddOrRemoveAsFav(viewData.templateId)">
              <div class="temp-star">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <g clip-path="url(#clip0_23206_10030)">
                  <path d="M9.87135 1.60996C10.0421 1.19932 10.6239 1.19932 10.7947 1.60996L12.8608 6.57744C12.9328 6.75056 13.0956 6.86885 13.2825 6.88383L18.6453 7.31376C19.0886 7.3493 19.2684 7.90256 18.9306 8.19189L14.8447 11.6919C14.7023 11.8139 14.6401 12.0053 14.6836 12.1876L15.9319 17.4208C16.0351 17.8534 15.5645 18.1954 15.1849 17.9635L10.5936 15.1592C10.4336 15.0615 10.2324 15.0615 10.0724 15.1592L5.48107 17.9635C5.10152 18.1954 4.63089 17.8534 4.73409 17.4208L5.98239 12.1876C6.0259 12.0053 5.96371 11.8139 5.82132 11.6919L1.73542 8.19189C1.39765 7.90256 1.57742 7.3493 2.02074 7.31376L7.38355 6.88383C7.57045 6.86885 7.73325 6.75056 7.80526 6.57744L9.87135 1.60996Z"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_23206_10030">
                  <rect width="20" height="20" fill="white" transform="translate(0.333008)"/>
                  </clipPath>
                  </defs>
                </svg>
              </div>
              Remove favorite
            </button>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="featured-icon {{viewData.iconColor}}">
              <span mwc-icon mwcIconfont={{viewData.icon}}></span>
            </div>
            <div class="template-card-title mwc-text-md-medium mwc-color-gray-800">{{viewData.title}}</div>
          </div>
          <div>
            <button mwc-button mwcSize="small" mwcType="primary" class="mwc-text-sm-medium" (click)="initializeNewArticle('AI', viewData)"> Use Template </button>
          </div>
        </div>
        <div mwc-row style="margin-top: 30px;height: calc(100vh - 285px);max-height: 377.2px;overflow: hidden;overflow-y: auto;">
          <div mwc-col [mwcSpan]="19">
            <div class="mwc-text-lg-medium mwc-color-gray-700 mb-2">Overview</div>
            <div class="mwc-text-sm-regular mwc-color-gray-500">{{viewData.summary}}</div>

            <div class="mwc-text-lg-medium mwc-color-gray-700 mt-3 mb-2">Workflow Advantages</div>
            <div>
              <ul style="padding-left: 16px;">
                <ng-container *ngFor="let whyUseText of viewData.whyUse">
                  <li class="mwc-text-sm-regular mwc-color-gray-500" [innerHTML]="FormattedText(whyUseText)" style="line-height: 22px; margin-bottom: 5px;"></li>                
                </ng-container>

                <!--<li class="mwc-text-sm-regular mwc-color-gray-500"><span class="mwc-text-md-medium mwc-color-gray-700">Transform Ideas Quickly:</span>Utilize AI to efficiently turn a blog outline or idea into a comprehensive post, accelerating your content creation process.</li>
                <li class="mwc-text-sm-regular mwc-color-gray-500"><span class="mwc-text-md-medium mwc-color-gray-700">Ensure Consistent Branding:</span>Maintain a unified brand voice and tone across your posts, reinforcing your brand identity and ensuring clear communication.</li>
                <li class="mwc-text-sm-regular mwc-color-gray-500"><span class="mwc-text-md-medium mwc-color-gray-700">Captivate Your Audience:</span>Deliver relevant, well-written content that resonates with your audience, addressing their interests and needs while keeping them engaged.</li>
                <li class="mwc-text-sm-regular mwc-color-gray-500"><span class="mwc-text-md-medium mwc-color-gray-700">Boost SEO Performance:</span>Develop content that's meticulously optimized for search engines, attracting more organic traffic and amplifying your online visibility.</li>-->
              </ul>
            </div>
          </div>
          <div mwc-col [mwcSpan]="5">
            <div class="mwc-text-md-medium mwc-color-gray-700 mb-2" style="margin-left: 10px !important;">Categories</div>
            <ul class="p-0 m-0" style="list-style: none;margin-left: 10px !important;">
              <ng-container *ngFor="let categories of viewData.templateCategories">
                <li>
                  <mwc-tag [mwcColor]="'gray'" class="d-inline-flex align-items-center gap-1 m-0" style="margin-bottom: 2px !important" [title]="categories">
                    <span mwc-icon mwcIconfont='arrow-up'></span>
                    <span class="categorie-name">{{categories}}</span>
                  </mwc-tag>
                </li>
              </ng-container>


              <!--<li><mwc-tag [mwcColor]="'gray'" class="d-inline-flex align-items-center gap-1 m-0"><span mwc-icon mwcIconfont='arrow-up'></span>Category 1</mwc-tag></li>
              <li><mwc-tag [mwcColor]="'gray'" class="d-inline-flex align-items-center gap-1 m-0"><span mwc-icon mwcIconfont='arrow-up'></span>Category 2</mwc-tag></li>
              <li><mwc-tag [mwcColor]="'gray'" class="d-inline-flex align-items-center gap-1 m-0"><span mwc-icon mwcIconfont='arrow-up'></span>Category 3</mwc-tag></li>-->
            </ul>
          </div>
        </div>
      </div>
    </mwc-spin>
  </div>
</div>

<ng-template #customSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

